import { SaveButton, Toolbar } from "react-admin";

/*
 * Toolbar component for edit forms without standard "Remove" button
 */
export const SaveOnlyToolbar = () => (
	<Toolbar>
		<SaveButton />
	</Toolbar>
);
